import { Component } from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';
import { IntlProvider, FormattedMessage } from 'react-intl';
import { LOCALES } from "./../translations/locales";
import { messages } from "./../translations/messages";
import { CookieMessage } from './CookieMessage';

export class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      locale: LOCALES.RUSSIAN,
    };
  }

  selectLanguage(e, language) {
    e.preventDefault();
    this.setState(prevState => ({...prevState, locale: language}));
  }

  render () {
    return (
      <IntlProvider messages={messages[this.state.locale]} locale={this.state.locale} defaultLocale={LOCALES.ENGLISH}>
        <CookieMessage/>
        <div class="layout">
          <NavMenu />
          <Container className="maincont">
            {this.props.children}
          </Container>
          <div class="footer border-top text-muted">
            <div class="container">
              &copy; 2026 - Planna - <a href="/privacy"><FormattedMessage id="policy"/></a> <a href="" onClick={(e) => this.selectLanguage(e, LOCALES.ENGLISH)}>EN</a> <a href="" onClick={(e)=>this.selectLanguage(e, LOCALES.RUSSIAN)}>RU</a>
            </div>
          </div>
        </div>
      </IntlProvider>
    );
  }
}